import { useEffect, useRef } from 'react';
import { trackUiEvent, UiEvent } from '../utils/uiAnalytics';

// Count each visible episode once, including under React StrictMode. Identity is
// used only for local deduplication and is never included in the event payload.
export const useAnalyticsExposure = (
  event: UiEvent,
  source: string,
  active: boolean,
  identity: unknown = undefined,
  action?: string,
): void => {
  const last = useRef<{ event: UiEvent; source: string; identity: unknown; action?: string } | null>(null);
  useEffect(() => {
    if (!active) {
      last.current = null;
      return;
    }
    if (last.current?.event === event && last.current.source === source &&
        last.current.identity === identity && last.current.action === action) return;
    last.current = { event, source, identity, action };
    trackUiEvent(event, source, action);
  }, [event, source, active, identity, action]);
};
